function Button({ children, onClick }) {
  return (
    <button className="text-cyan-blue" onClick={onClick}>
      {children}
    </button>
  );
}

export default Button;